module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_1500_Active@1x-41b476d7361ce3e19dd1697c42de26a6.png";